window.theme = window.theme || {};
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
 if (typeof cents == 'string') { cents = cents.replace('.',''); }
 var value = '';
 var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
 var formatString = (format || this.money_format);
 function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
 }
 function formatWithDelimiters(number, precision, thousands, decimal) {
   precision = defaultOption(precision, 2);
   thousands = defaultOption(thousands, ',');
   decimal   = defaultOption(decimal, '.');
   if (isNaN(number) || number == null) { return 0; }
   number = (number/100.0).toFixed(precision);
   var parts   = number.split('.'),
       dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
       cents   = parts[1] ? (decimal + parts[1]) : '';
   return dollars + cents;
 }
 switch(formatString.match(placeholderRegex)[1]) {
   case 'amount':
     value = formatWithDelimiters(cents, 2);
     break;
   case 'amount_no_decimals':
     value = formatWithDelimiters(cents, 0);
     break;
   case 'amount_with_comma_separator':
     value = formatWithDelimiters(cents, 2, '.', ',');
     break;
   case 'amount_no_decimals_with_comma_separator':
     value = formatWithDelimiters(cents, 0, '.', ',');
     break;
 }
 return formatString.replace(placeholderRegex, value);
}; 
Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

function debounce(func, wait){
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => { func.apply(this, args); }, wait);
  };
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
    return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; 
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

document.addEventListener("DOMContentLoaded", (event) => {
  // $('.header-main-link').click(function(e) {
  //     // e.preventDefault();
  //     $(this).toggleClass("open");
  // }); 
  // $('.site-nav__item_child').click(function(e) {
  //     // e.preventDefault();
  //     $(this).toggleClass("open");
  // }); 
  let headerMainLinks = document.querySelectorAll('.header-main-link');
  let navLinkChilds = document.querySelectorAll('.nav__item_child');
  if(headerMainLinks){
    headerMainLinks.forEach((headerLink)=>{
      headerLink.addEventListener('click',function(){
        this.classList.toggle('open');
      });
      headerLink.addEventListener('mouseover',function(){
        let menuImageSlider = this.querySelector('.menu-img-slider');
        if(menuImageSlider){
          setTimeout(function(){
          let menuSliderEleme = new Flickity( menuImageSlider, {
            autoPlay: true,
            autoPlay: 1500,
            pageDots: false,
            cellAlign: 'left',
            wrapAround: true,
            prevNextButtons: false,
            contain: true
          });
            },100);
        }
      })
    });
  }
  if(navLinkChilds){
    navLinkChilds.forEach((navLinkChild)=>{
      navLinkChild.addEventListener('click',function(){
       this.classList.toggle('open');
      })
    })
  }
  
  window.onload = onPageLoad();
  function onPageLoad() {
    let sort;
    window.location.search.slice(1).split('&').forEach(url => {
      if (url.indexOf("sort_by") >= 0){
        sort = url.split('=')[1];
      }
    });
    document.querySelectorAll('#filtersortmobile .mobile-filter__label').forEach(button => {
      if(button.querySelector('.mobile-sort__checkbox').value == sort){
        button.querySelector('.mobile-sort__checkbox').checked = true;
      }else{
        button.querySelector('.mobile-sort__checkbox').checked = false;
      }
    });
  }
}); 
document.addEventListener("DOMContentLoaded", (event) => {
let headerElement = document.querySelector('.header-section');
let stickyHeader = headerElement.getAttribute('data-fixed-header') 
let MainHeader = document.querySelectorAll('.shopify-section-group-header-groups')
let headerLimit = headerElement.offsetTop + headerElement.offsetHeight + 50;
  if(stickyHeader == 'true'){
    window.addEventListener('scroll',function(){
      let scroll = window.scrollY;
      if(scroll > headerLimit){
        MainHeader[1].classList.add('fixed-header')
      }
      else{
        MainHeader[1].classList.remove('fixed-header')
      }
    });
  }
});
(function() {


  window.lazySizesConfig = window.lazySizesConfig || {};
  window.lazySizesConfig.customMedia = {
      '--small': '(max-width: 480px)',
      '--medium': '(max-width: 700px)'
  };
  

  
  class MenuDrawer extends HTMLElement {
    constructor() {
      super();
      
      this.mainDetailsToggle = this.querySelector('details');
      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.bindEvents();
    }
  
    bindEvents() {
      this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
  
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
  
      const openDetailsElement = event.target.closest('details[open]');
      if(!openDetailsElement) return;
  
      openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }
  
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.has-submenu');
      const isOpen = detailsElement.hasAttribute('open');
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  
      function addTrapFocus() {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
        summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
      }
      if (detailsElement === this.mainDetailsToggle) {
        if(isOpen) event.preventDefault();
        isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
  
        if (window.matchMedia('(max-width: 990px)')) {
          document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
        }
      } else {
        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
          parentMenuElement && parentMenuElement.classList.add('submenu-open');
          !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
      }
    }
  
    openMenuDrawer(summaryElement) {
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
  
    closeMenuDrawer(event, elementToFocus = false) {
      if (event === undefined) return;
  
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
        submenu.classList.remove('submenu-open');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  
    onFocusOut(event) {
      setTimeout(() => {
        if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
      });
    }
  
    onCloseButtonClick(event) {
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
  
    closeSubmenu(detailsElement) {
      const parentMenuElement = detailsElement.closest('.submenu-open');
      parentMenuElement && parentMenuElement.classList.remove('submenu-open');
      detailsElement.classList.remove('menu-opening');
      detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
      removeTrapFocus(detailsElement.querySelector('summary'));
      this.closeAnimation(detailsElement);
    }
  
    closeAnimation(detailsElement) {
      let animationStart;
      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }
        const elapsedTime = time - animationStart;
        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
          if (detailsElement.closest('details[open]')) {
            trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
          }
        }
      }
  
      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('menu-drawer', MenuDrawer);



  // footer mobile accordion
  var accItem = document.getElementsByClassName('footer-quicklinks');
  var accHD = document.getElementsByClassName('footer-menu-title');
  for (i = 0; i < accHD.length; i++) {
      accHD[i].addEventListener('click', toggleItem, false);
  }
  function toggleItem() {
    var itemClass = this.nextElementSibling.className;
    for (i = 0; i < accItem.length; i++) {
        accItem[i].className = 'sub-elements footer-quicklinks hide';
    }
    if (itemClass == 'sub-elements footer-quicklinks hide') {
      this.nextElementSibling.className = 'sub-elements footer-quicklinks show';
      this.className = 'link footer-title footer-menu-title open';
    }else{
      this.className = 'link footer-title footer-menu-title close';
    }
  }

  // footer currency change
  function currencyFormSubmit(event) {
    event.target.form.submit();
  }
  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });

  // shop-all-collection
  var addColl = document.getElementsByClassName('shop-all-button');
  for (i = 0; i < addColl.length; i++) {
    addColl[i].addEventListener('click', addItem, false);
  }
  function addItem(e){
    e.preventDefault();
    var quantity = 1 ;
    var product_wrap = this.parentElement.previousElementSibling.childNodes[1];
    var ids = product_wrap.children;
    let data = [];
    for (let i = 0; i < ids.length; i++) {
      var id = ids[i].getAttribute('data-variant-id');
      if(id){
        data.push(id);
      }
    }
    Shopify.moveAlong = function() {
      if (data.length) {
        var request = data.shift();
        var dataval = 'id='+ request + '&quantity=1';
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: dataval,
          success: function(data){
            Shopify.moveAlong();
            quantity += 1;
            $("#cartDrawer").load(location.href + " #cartDrawer>*", "");
            $(".icons-wrapper").load(location.href + " .icons-wrapper>*", "");
          },
          error: function(){
            if (data.length){
              Shopify.moveAlong()
            }
          },
          complete: function (data) {
            $('.cartDrawer').addClass('open');
          }
        });
      }
    }
    Shopify.moveAlong();      
  }
})();

let mbFilterbtn = document.querySelector('.mb-filter-close,.collection-filter-overly');
let mainCollectionFilterContainer = document.getElementById('main-collection-filters');
let mbFilterClose = document.querySelector('.md-filter');
mbFilterbtn?.addEventListener('click',function(){
  mainCollectionFilterContainer?.classList.add('mb-active');
});
mbFilterbtn?.addEventListener('click',function(){
  mainCollectionFilterContainer?.classList.remove('mb-active');
})
class ScrollToNextsection extends HTMLElement{
 constructor(){
   super()
   this.button = this;
 } 
  connectedCallback(){
    this.init()
  }
  init(){
    this.button.addEventListener('click',this.scrollTonext)
  }
  scrollTonext(e){
    event.preventDefault();
    let nextSection = this.closest('.shopify-section').nextElementSibling;
    if(!nextSection) return;
    let scrollAmount = nextSection.offsetTop;
     window.scrollTo({
            top: scrollAmount,
            behavior: "smooth"
        }); 
  }
}

customElements.define('scroll-next', ScrollToNextsection);

function scrollToNext(){
    let anchorList = document.querySelector('.scroll_to_next').parentElement.parentElement.nextElementSibling;
    anchorList.scrollIntoView({behavior: "smooth"});
}
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);
  

// countdown
(function() {
  if(document.querySelector('.countdown')){
    var date = document.querySelector('.countdown').dataset.val;
    target_date = new Date(date).getTime();
    var days, hours, minutes, seconds;

    var countdown = document.querySelectorAll(".tiles");
    getCountdown();
    var myInterval = setInterval(function () { getCountdown(); }, 1000);

    function getCountdown(){

      var currentTime = new Date();
      var currentOffset = currentTime.getTimezoneOffset();
      var ISTOffset = 330;   // IST offset UTC +5:30 
      var ISTTime = new Date(currentTime.getTime() + (ISTOffset + currentOffset)*60000);

      var current_date = ISTTime.getTime();
      var seconds_left = (target_date - current_date) / 1000;

      days = pad( parseInt(seconds_left / 86400) );
      seconds_left = seconds_left % 86400;
            
      hours = pad( parseInt(seconds_left / 3600) );
      seconds_left = seconds_left % 3600;
            
      minutes = pad( ("0" + parseInt(seconds_left / 60)).slice(-2) );
      seconds = pad( ("0" + parseInt( seconds_left % 60 )).slice(-2) );

      var d = days != '00' ? "<li><h3>" + days + "</h3>Days</li>" : "";
      var h = hours != '00' ? "<li><h3>" + hours + "</h3>Hours</li>" : "";
      var m = hours != '00' || minutes != '00' ? "<li><h3>" + minutes + "</h3>Minutes</li>" : "";
      var s = "<li><h3>" + seconds + "</h3>Seconds</li>";

      
      countdown.forEach(element => element.innerHTML = d + h + m + s);

      if(days == '00' && hours == '00' && minutes == '00' && seconds == '00'){
        clearInterval(myInterval);
        $('.countdown').hide();
      }
    }
    function pad(n) {
      return n;
    }
  }
})();
document.addEventListener("DOMContentLoaded", (event) => {
class VideoSection extends HTMLElement{
  constructor(){
    super()
    this.playButton = this.querySelector('.video-play-button');
  }
  connectedCallback(){
    this.init();
  }
  init(){
    this.playButton.addEventListener('click',function(){
      console.log('clicked')
      this.querySelector('.video').classList.add('play-video');
      let symbol = this.querySelector('iframe').src.indexOf("?") > -1 ? "&":"?";
      this.querySelector('iframe').src += symbol+"autoplay=1";
    }.bind(this));
  }
}
customElements.define('video-section', VideoSection);
    // update quantity
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true })

      this.querySelectorAll('button').forEach(
        
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );
      this.input.addEventListener('change',this.quantityChange.bind(this))
      this.input.addEventListener('keydown',this.quantityChange.bind(this))
    }
    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;

      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

      if(this.closest('product-submit')){
        let quantityInput = this.closest('product-submit').querySelector('#productQuantity');
        quantityInput.value = this.input.value;
      }
    }
    quantityChange(event){
      // this.input = event.target;
      if(event.code == 'NumpadSubtract'){
        return ;
      }
      
      if(this.closest('product-submit')){
        let quantityInput = this.closest('product-submit').querySelector('#productQuantity');
        
          quantityInput.value = event.target.value;
          this.input = this.querySelector('input');
      }
    }
  }
  
  customElements.define('quantity-input', QuantityInput);
});
// globle js

let bodyPart = document.querySelector('.body-part');
let garmentPart = document.querySelector('.garment-part');
let sizeButtons = document.querySelectorAll('.size-btn');
let garmentBtn = document.querySelector('.garment-btn');
let SizeBodyBtn = document.querySelector('.size-btn.body-btn');
let siteHeaderMenu = document.querySelector('.site-header__menu');
let headerMobileNavigationWrapper = document.querySelector('.header-mobile-navaigation-wrapper');
let sitHeaderMenuClose = document.querySelector('.mobile-menu-top-part .icon-close-wrapper'); 
let subTitles = document.querySelectorAll('.sub-title'); 
let mobileNavGrandChildIcon = document.querySelector('.mobile-nav__has-grandchild-icon'); 
let mobileNavIcons = document.querySelectorAll('.mobile-nav__icon'); 
let searchIcon = document.querySelector('.header-section .icon-search'); 
let searchModal = document.querySelector('.search-modal');
let searchModalClosebtn = document.querySelector('.search-modal .icon-close-wrapper');

searchModalClosebtn?.addEventListener('click',function(){
   searchModal.classList.remove('open');
  document.body.classList.remove('no-scroll');
})

searchIcon?.addEventListener('click',function(){
  searchModal.classList.add('open');
   this.nextElementSibling.querySelector('.search__input').focus();
   document.body.classList.add('no-scroll');
});

if(mobileNavIcons){
  mobileNavIcons.forEach(function(mobileNavIcon,index){
    mobileNavIcon?.addEventListener('click',function(){
      this.parentNode.classList.toggle('open');
    });  
  });
}
mobileNavGrandChildIcon?.addEventListener('click',function(){
  this.classList.toggle('open')
})

if(subTitles){
  subTitles.forEach(function(subTitle){
    subTitle?.addEventListener('click',function(){
      this.parentNode.previousSibling.classList.remove('open')
    });    
  });
}


  siteHeaderMenu?.addEventListener('click',function(){
    headerMobileNavigationWrapper.classList.add('open');
    document.body.classList.add('no-scroll');
  });

  sitHeaderMenuClose?.addEventListener('click',function(){
    headerMobileNavigationWrapper.classList.remove('open');
    document.body.classList.remove('no-scroll');
  })
  garmentBtn?.addEventListener('click',function(e){
    e.preventDefault();
    bodyPart.style.display = "none";
    garmentPart.style.display = "block";
    sizeButtons.forEach(function(sizebtn){
      sizebtn.classList.remove('active');
    });
    this.classList.add('active');
  })
  SizeBodyBtn?.addEventListener('click',function(e){
    e.preventDefault();
    bodyPart.style.display = "table";
    garmentPart.style.display = "none";
    sizeButtons.forEach(function(sizebtn){
      sizebtn.classList.remove('active');
    });
    this.classList.add('active');
  });
function isInt(n) {
    if (n % 1 === 0) {
        return Math.abs(n);
    } else {
        return n;
    }
}
document.addEventListener("DOMContentLoaded", (event) => {
  let sizeGuideButton = document.querySelector('#sizeGuid');
  let sizeGuidPopupcontainer = document.querySelector('.size-popup-conntent-box');
  let closeSizepopupBtn = document.querySelector('.size-popup-close')
  
  sizeGuideButton?.addEventListener('click',function(e){
    e.preventDefault();
    sizeGuidPopupcontainer.classList.add('is-visible');
    document.body.classList.add('no-scroll');
  });
  closeSizepopupBtn?.addEventListener('click',function(){
    sizeGuidPopupcontainer.classList.remove('is-visible');
    document.body.classList.remove('no-scroll');
  });

  let tabNavs = document.querySelectorAll('#tabs-nav li');
  let tabContents = document.querySelectorAll('.tab-content')
  tabNavs.forEach(function(nav){
    nav.addEventListener('click',function(e){
      e.preventDefault();
      let activeId = this.querySelector('a').getAttribute('href')
      if(this.classList.contains('active')) return;
      tabNavs.forEach(function(btn,index){
        btn.classList.remove('active');
        document.querySelector(`#tab${index+1}`).classList.remove('active');
      });
      this.classList.add('active')
      document.querySelector(activeId).classList.add('active');
    })
  });

  let toggleBox = document.querySelector('.toggle-box input[type="checkbox"]');
  
  toggleBox.addEventListener('change',function(e){
    let popupSpan = document.querySelectorAll('#size-popup span');
    let popupTd = document.querySelectorAll('#size-popup td'); 
    let isChecked = this.checked
    
       if(isChecked){
      popupSpan.forEach(function(span,index){
        let valueCenti = parseFloat(span.innerHTML * 2.54).toFixed(2);
          span.innerHTML = isInt(valueCenti);
      })
      popupTd.forEach(function(td,index){
         td.innerHTML = td.innerHTML.replaceAll('"', "cm");
      });
    }
    else{
      popupSpan.forEach(function(span,index){
        let valueInch = parseFloat(span.innerHTML / 2.54).toFixed(2);
          span.innerHTML = isInt(valueInch);
      });
      popupTd.forEach(function(td,index){
         td.innerHTML = td.innerHTML.replaceAll('cm', '"');
      });
    }
  });
});
class ProductSubmit extends HTMLElement{
  constructor(){
    super();
    this.container = this
    this.form = this.container.querySelector('form');
    this.submitButton = this.container.querySelector('.submitProduct');
    this.form.addEventListener('submit',this.submitForm.bind(this))
    this.errorElement = this.container.querySelector('.error-message') || this.container.querySelector('.product-add-error');
    this.bunNowButton = this.container.querySelector('[data-buynow]');
    if(this.bunNowButton){
      this.bunNowButton.addEventListener('click',this.onBuyNowbutton.bind(this))
    }
  }
  
  submitForm(event){
    event.preventDefault();
    this.setLoading();
    const formData = new FormData(this.form);

    fetch(`${window.cart.add_url}.js`,{
      method:"POST",
      headers:{
        Accept: "application/javascript",
        'X-Requested-With':'XMLHttpRequest'
      },
      body:formData
    }).then((data)=>{
      return data.json();
    }).then((response)=>{
      if(response.status == 422){
        if(this.errorElement){
          let ErrorMessageContainer = this.querySelector('#productErrormessage');
          if(ErrorMessageContainer){
            ErrorMessageContainer.classList.remove('hide');
          }
          this.errorElement.innerHTML = response.description  
        }
      }
      else{
        if(this.errorElement){
          let ErrorMessageContainer = this.querySelector('#productErrormessage');
          if(ErrorMessageContainer){
            ErrorMessageContainer.classList.add('hide');
          }
          this.errorElement.innerHTML = '';
        }
        this.formSuccess()
      }
      this.removeLoading();
          
    }).
      catch(function(e){
        console.log(e)
        this.formSuccess()
        console.error(e)
      });
  }
  onBuyNowbutton(event){
    event.preventDefault();
    let productForm = document.querySelector('product-submit');
    let quantity = productForm.querySelector('[name="quantity"]').value
    let variantId = event.target.getAttribute('data-variantid');
    
    if(event.target.getAttribute('data-variantid')){
      window.location.href = `/cart/${variantId}:${quantity}`;  
    }
    
  }
  setLoading(){
    this.submitButton.classList.add('productSubmit--btn--loading');
  }
  removeLoading(){
    this.submitButton.classList.remove('productSubmit--btn--loading');
  }
  formSuccess(){
    let cart = document.querySelector('shopping-cart')
    cart.updateCartDrawer();
    cart.updateCartcontentOutside()
    cart.getCartJson()
    cart.openShippingCart()

  }
}

customElements.define('product-submit',ProductSubmit)

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
       this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    let elementMedia = document.querySelector('.product-media[data-media-id="'+this.currentVariant.featured_media.id+'"]')
    let slideIndex = parseInt(elementMedia.getAttribute('data-slide-index'))
    if(window.Shopify.product?.mainSlider){
      window.Shopify.product?.mainSlider.selectCell(slideIndex);  
    }
    if(window.Shopify.stackMobileSlider){
      window.Shopify.stackMobileSlider.selectCell(slideIndex);  
    }
    
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl(html) {
    
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    const source = html?.getElementById(`Share-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && shareButton) shareButton.innerHTML = source.innerHTML;
      if (!shareButton || !shareButton.updateUrl) return;
     shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    
    const inputWrappers = [...this.querySelectorAll('.variant-wrapper')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);
        this.updateShareUrl(html)
      });
    
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
  
let accordians = document.querySelectorAll('.accordion__title');
  Array.from(accordians).forEach(function(button,index){
    button.addEventListener('click',function(event){
      this.parentNode.classList.toggle('open')
    });
  });



document.addEventListener("DOMContentLoaded", (event) => {
  let cartIcon = document.getElementById('cartIcon');
  let cartDrawerContainer = document.getElementById('cartDrawer')
  let cartOverlay = document.querySelector('.cart-overly')
  cartIcon.addEventListener('click',function(){
    cartDrawerContainer.openShippingCart();
  });
  cartOverlay.addEventListener('click',function(){
    cartDrawerContainer.closeShippingCart()
  });
});
document.addEventListener("DOMContentLoaded", (event) => {
  let languageConverter = document.querySelectorAll('[name="currency"],[name="language_code"]');
  if(languageConverter){
    languageConverter.forEach(function(element){
      element.addEventListener('change',function(){
        this.closest('form').submit();
      })
    });
  }
  let menuDropDown = document.querySelectorAll('.item_top_level .desktop-arrow-icon');
  if(menuDropDown){
    menuDropDown.forEach(function(dropdownMenu){
      dropdownMenu.addEventListener('click',function(e){
        e.preventDefault();
        this.parentNode.parentNode.classList.toggle('open');
      })
    })
  }
  
});
const productSlideShowContainer = document.querySelector('[data-product-slideshow]');
const productThumbSlideShowContainer = document.querySelector('[data-product-thumbs]');
const productMediaGridMobileSlider = document.querySelector('.product-media-grid-mobile-slider');

window.Shopify.product = new Object();
if(productSlideShowContainer && productThumbSlideShowContainer){
  const verticalSlider = productThumbSlideShowContainer.getAttribute('data-slider') =='vertical' ? true:false
  const productSlideShow = new Flickity(productSlideShowContainer,{
    cellAlign: 'left',
    adaptiveHeight: true,
    groupCells: true,
    contain: true,
    prevNextButtons: true,
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 65, y2: 45,
      x3: 20
    }
  });
  window.Shopify.product.mainSlider = productSlideShow;

  
  const thumbSlideShow = new Flickity(productThumbSlideShowContainer,{
    cellAlign: 'left',
    groupCells: true,
    asNavFor:'.slider-for',
    contain: true,
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 65, y2: 45,
      x3: 20
    }
  });
  window.Shopify.product.thumbSlider = thumbSlideShow;
  document.addEventListener("DOMContentLoaded", (event) => {
    window.Shopify.product.thumbSlider.resize()
  });
   
   if(!verticalSlider){
      window.Shopify.stackMobileSlider = new Object();
    if (window.matchMedia("(max-width: 768px)").matches) {
      if(productMediaGridMobileSlider){
        const mobileGridSlideshow = new Flickity(productMediaGridMobileSlider,{
          cellAlign: 'left',
          groupCells: true,
          contain: true,
          prevNextButtons: false,
          pageDots: false
        });
        window.Shopify.stackMobileSlider = mobileGridSlideshow;
      }
    }
     else{
       window.Shopify.stackMobileSlider = false
     }
   }
    
}
// globle component js
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.dots = this.getAttribute('data-dots')
    
    if (!this.slider || !this.nextButton ) return;

    this.initPages();
    this.autorotateSlides();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    if(this.dots == 'true'){
      this.dotsElementes = this.querySelectorAll('.slider-dot-item')
      Array.from(this.dotsElementes).forEach((element)=>{
        element.addEventListener('click',this.onDotsClick.bind(this))
      });
    }
    
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
    
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();

  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
      
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
      
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
    
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = parseInt(event.currentTarget.dataset.step || 1);

    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
        this.slider.scrollTo({
          left: this.slideScrollPosition,
        });
    
        if(this.dotsElementes){
            Array.from(this.dotsElementes).forEach((item)=>{
              if(item.classList.contains('active')){
                item.classList.remove('active');
              }
            });
          let currentSlide = this.sliderItemsToShow[this.currentPage - 1];
          let currentIndex = currentSlide.getAttribute('data-slideindex');
          document.querySelector('.slider-dot-item[data-steps="'+currentIndex+'"]')?.classList.add('active');
        }
     
  }
  onDotsClick(event){
     if(event.target.classList.contains('active')){
       return
     }
    Array.from(this.dotsElementes).forEach((item)=>{
      if(item.classList.contains('active')){
        item.classList.remove('active');
      }
    });
     const step = event.currentTarget.dataset.steps || 1;
     this.slider.scrollTo({left: step * this.sliderItemOffset});
     
     event.target.classList.add('active');
  }

  rotateSlide(){
    this.slideScrollPosition = this.slider.scrollLeft + 1 * this.sliderItemOffset;
    this.slider.scrollTo({
          left: this.slideScrollPosition,
        });
  }

  autorotateSlides(){
    // setInterval(function(){
    //   this.rotateSlide();  
    // }.bind(this),2000)
    
  }
}

customElements.define('slider-component', SliderComponent);

function slideTriggerbyId(event,button){
  document.getElementById(button)?.resetPages();
  document.getElementById(button)?.onButtonClick(event);
}



